// extracted by mini-css-extract-plugin
export default {"ContainerStyle":"Loader_ContainerStyle__RtJI9","LoaderImageStyle":"Loader_LoaderImageStyle__xOKNL"};